import React, { useEffect, useState } from 'react';
import { Button, Dialog, DialogContent, DialogTitle, IconButton } from '@mui/material';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import { CUSTOM_EVENTS } from '../../../../../utils/constants';
import MarkAsComplete from './MarkAsComplete';
import PrescriptionDialog from './PrescriptionDialog';
import { useAppointmentContext } from '../contexts/appointmentcontext';

function UploadPrescription() {
    const { appointment } = useAppointmentContext();
    const [openUploadPrescription, setOpenUploadPrescription] = useState(false);

    const toggleUploadPrescription = (toggle) => () => {
        setOpenUploadPrescription(toggle);
    };

    // Register event for prescription dialog toggle
    useEffect(() => {
        const togglePrescriptionDialog = (e) => {
            const data = e.detail;
            setOpenUploadPrescription(data);
        };
        document.addEventListener(CUSTOM_EVENTS.TOGGLE_PRESCRIPTION_DIALOG, togglePrescriptionDialog);
        return () => {
            document.removeEventListener(CUSTOM_EVENTS.TOGGLE_PRESCRIPTION_DIALOG, togglePrescriptionDialog);
        };
    }, []);

    const prescriptionDialog = appointment && openUploadPrescription && (
        <Dialog open={openUploadPrescription} maxWidth='xs' fullWidth>
            <DialogTitle sx={{ display: 'flex', alignItems: 'center' }}>
                <div style={{ flex: 1 }}>Upload Prescription</div>
                <IconButton size='small' onClick={toggleUploadPrescription(false)}>
                    <CloseOutlinedIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <PrescriptionDialog />
            </DialogContent>
        </Dialog>
    );

    const prescriptionUI = (
        <>
            {prescriptionDialog}
            <Button variant='contained' color='warning' onClick={toggleUploadPrescription(true)}>Upload Prescription</Button>
        </>
    );

    const statusCompletionUI = appointment && <MarkAsComplete />;

    const renderPrescriptionUI = () => {
        if (appointment && appointment.prescription) {
            return statusCompletionUI;
        }
        return prescriptionUI;
    };

    return (
        <>
            {renderPrescriptionUI()}
        </>
    );
}

export default UploadPrescription;

